/**
 * artikelimport — App-Shell.
 *
 * Stand Phase 1–7: zwei Reiter statt der fuenf Schritte aus §11. „Quelle" waehlt die
 * Datei und zeigt, was daraus wuerde; „Entwuerfe" haelt gespeicherte Vorhaben, die
 * Auswahl und den Probelauf. Die Fortschrittsleiste ueber alle fuenf Schritte kommt,
 * wenn der Schreiblauf steht — vorher waere sie ein Versprechen ohne Deckung.
 *
 * Seit 30.09.2026 ein vierter Reiter „Historie": jeder scharfe Lauf und was er in Plenty
 * hinterlassen hat, mit Abgleich auf Klick. Verworfene Entwuerfe verschwinden aus
 * „Entwuerfe" — ihre Laeufe nicht aus der Historie.
 */
import { useState } from 'react';
import EntwuerfePage from './pages/EntwuerfePage';
import HerstellerPage from './pages/HerstellerPage';
import HistoriePage from './pages/HistoriePage';
import QuellePage from './pages/QuellePage';

type Reiter = 'quelle' | 'entwuerfe' | 'hersteller' | 'historie';

export default function ArtikelimportApp() {
  const [reiter, setReiter] = useState<Reiter>('quelle');
  /** Nach „Entwurf erstellen" springt die Quelle direkt in den neuen Entwurf (02.10.2026). */
  const [oeffneEntwurf, setOeffneEntwurf] = useState<number | null>(null);

  return (
    <div>
      <nav className="flex gap-1 border-b border-[#DAD9D9] px-6 pt-4">
        {([['quelle', 'Quelle'], ['entwuerfe', 'Entwürfe'], ['hersteller', 'Hersteller'], ['historie', 'Historie']] as Array<[Reiter, string]>).map(
          ([schluessel, label]) => (
            <button
              key={schluessel}
              type="button"
              onClick={() => setReiter(schluessel)}
              className={`rounded-t border-b-2 px-4 py-2 text-sm ${
                reiter === schluessel
                  ? 'border-[#1A1A1A] font-medium text-[#1A1A1A]'
                  : 'border-transparent text-[#1A1A1A]/60 hover:text-[#1A1A1A]'
              }`}
            >
              {label}
            </button>
          ),
        )}
      </nav>
      {reiter === 'quelle' && (
        <QuellePage aufEntwurf={id => { setOeffneEntwurf(id); setReiter('entwuerfe'); }} />
      )}
      {reiter === 'entwuerfe' && <EntwuerfePage oeffneId={oeffneEntwurf} aufGeoeffnet={() => setOeffneEntwurf(null)} />}
      {reiter === 'hersteller' && <HerstellerPage />}
      {reiter === 'historie' && <HistoriePage />}
    </div>
  );
}
